import { render } from "./list.vue?vue&type=template&id=136d3fa4&scoped=true&ts=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"

import "./list.vue?vue&type=style&index=0&id=136d3fa4&lang=scss&scoped=true"

import exportComponent from "/tmp/build_c94111dd/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-136d3fa4"]])

export default __exports__